import { v4 as uuidv4 } from 'uuid'

export const aumTotalTestData = () => {
  return {
    title: 'AUM Total',
    item: '17.5 Billion',
    key: uuidv4()
  }
}
